import { cn } from '@goaltree/ui/lib/utils'
import { SparklesIcon, X } from 'lucide-react'

export function CoachCard({
  message,
  onDismiss,
  className,
}: {
  message: string
  onDismiss: () => void
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex items-start gap-3 rounded-xl border border-primary/30 bg-primary/5 px-4 py-3 mb-3',
        className,
      )}
    >
      <SparklesIcon className="mt-0.5 h-4 w-4 shrink-0 text-primary-text/70" strokeWidth={1.5} />
      <p className="flex-1 text-sm text-foreground/80">{message}</p>
      <button
        type="button"
        onClick={onDismiss}
        className="cursor-pointer mt-0.5 flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded text-muted-foreground/40 transition-colors hover:text-muted-foreground"
        aria-label="Dismiss coach message"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}
